import { isEmpty } from 'lodash-es';
import { propOr } from 'ramda';
import { normalizeBonusSystemWager } from '../../normalizers';
import { useBonusesStore } from '../../store';

const selectCrmWagerBonuses = () => propOr([], 'crmWagerBonuses');
const selectBsWagerBonus = () => propOr({}, 'bsWagerBonus');

export const useWagerBonuses = () => {
  const crmWagerBonuses = useBonusesStore(selectCrmWagerBonuses());
  const bsWagerBonus = useBonusesStore(selectBsWagerBonus());

  let wagerBonuses = crmWagerBonuses.sort(
    (a, b) =>
      new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime()
  );

  if (!isEmpty(bsWagerBonus)) {
    wagerBonuses = [normalizeBonusSystemWager(bsWagerBonus), ...wagerBonuses];
  }

  return wagerBonuses;
};
